import { Fancybox } from "@fancyapps/ui";

import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import focus from '@alpinejs/focus'
 
import initInformationPage from "./information-page"
import initFlowFilter from "./flow-filter"

Alpine.plugin(focus)
Alpine.plugin(collapse)
Alpine.data('clickToCopy', () => ({
    copied: false,
    copyText(el: HTMLButtonElement) {
        const copyText = el?.getAttribute('data-copytext')
        navigator.clipboard.writeText(copyText)
        this.copied = true

        setTimeout(() => {
            this.copied = false
        }, 1500);
    }
}))
Alpine.store('navOpen', false)
Alpine.store('isDesktop', false) // This is set in _PrimaryNavigation

Alpine.start()

Fancybox.bind("[data-fancybox]", {})

if (document.querySelector('#InformationPage'))
{
    initInformationPage()
}

if (document.querySelector('#Flow'))
{
    initFlowFilter()
}